export const requiredMessage = "Пожалуйста, заполните обязательные поля";
//# sourceMappingURL=requiredMessage.js.map